import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
    EntityDataService, EntityDefinitionService, EntityMetadataMap, HttpUrlGenerator, Logger
} from '@ngrx/data';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { OrderModule } from 'ngx-order-pipe';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { SliderModule } from 'primeng/slider';
import { TableModule } from 'primeng/table';
import { EntityDataServiceWrapper } from '../../state/entity/entity-data-service-wrapper';
import { AdminSatelliteSurveillanceModule } from './admin-satellite/surveillance/admin-satellite-surveillance.module';
import { BlockTimesProximityComponent } from './blockTimesAndProximity/block-times-proximity.component';
import { BlockTimesProximityActions } from './blockTimesAndProximity/state/block-times-proximity.actions';
import { BlockTimesProximityEffects } from './blockTimesAndProximity/state/block-times-proximity.effects';
import {
    BlockTimesProximityReducer,
    STORE_FEATURE_KEY_BLOCK_TIMES_PROXIMITY
} from './blockTimesAndProximity/state/block-times-proximity.reducer';
import { BlockTimesProximitySelectors } from './blockTimesAndProximity/state/block-times-proximity.selectors';
import { availableUserStatusesStateReducer, STORE_FEATURE_USER_STATUS } from './state/admin.reducer';
import {
    availableDeviceDataServiceConfig,
    availableDeviceEntityMetadata
} from './user/devices/available-devices.entity';
import { UserDevicesModule } from './user/devices/user-devices.module';
const adminEntityMetadata: EntityMetadataMap = {
    [availableDeviceEntityMetadata.entityName]: availableDeviceEntityMetadata
};

@NgModule({
    imports: [
        CommonModule,
        OrderModule,
        StoreModule.forFeature(STORE_FEATURE_USER_STATUS, availableUserStatusesStateReducer),
        EffectsModule.forFeature([BlockTimesProximityEffects]),
        StoreModule.forFeature(STORE_FEATURE_KEY_BLOCK_TIMES_PROXIMITY, BlockTimesProximityReducer),
        UserDevicesModule,
        ButtonModule,
        AdminSatelliteSurveillanceModule,
        SliderModule,
        FormsModule,
        BrowserModule,
        BrowserAnimationsModule,
        CalendarModule,
        TableModule,
        BsDatepickerModule.forRoot(),
        DropdownModule,
        NgxSliderModule
    ],
    declarations: [
        BlockTimesProximityComponent
    ],
    providers: [
        BlockTimesProximityActions,
        BlockTimesProximitySelectors
    ]
})
export class AdminModule {
    constructor(httpClient: HttpClient,
                httpUrlGenerator: HttpUrlGenerator,
                logger: Logger,
                entityDataService: EntityDataService,
                entityDefinitionService: EntityDefinitionService) {
        entityDefinitionService.registerMetadataMap(adminEntityMetadata);

        entityDataService.registerService(
            availableDeviceDataServiceConfig.entityName,
            new EntityDataServiceWrapper(availableDeviceDataServiceConfig, httpClient, httpUrlGenerator, logger)
        );
    }
}
